<script>
import { assetURL } from '../../utils/url';
import OclpPolicy from './OclpPolicy.vue';
import OccPolicy from './OccPolicy.vue';

export default {
    components: {
        OclpPolicy,
        OccPolicy
    },
    data() {
        return {
            activePolicy: 'OCLP',
            showDropdown: false,
            oclpImage: assetURL + 'images/icons/OCLP_SEAL_06162026.png',
            occImage: assetURL + 'images/icons/OCC_SEAL_06162026.png',
        };
    },
    mounted() {
        function scrollFunction() {
            const mybutton = document.getElementById('scroll-top');
            if (
                document.body.scrollTop > 20 ||
                document.documentElement.scrollTop > 20
            ) {
                mybutton.style.display = 'block';
            } else {
                mybutton.style.display = 'none';
            }
        }
        window.onscroll = function () {
            scrollFunction();
        };
        window.addEventListener('click', (e) => {
            if (!e.target.closest('.tw-w-64')) {
                this.showDropdown = false;
            }
        });
    },
};
</script>

<template>
    <div class="tw-grid tw-grid-cols-[5%_90%_5%] xl:tw-grid-cols-[15%_70%_15%] 2xl:tw-grid-cols-[15%_70%_15%]">
        <div></div>
        <div class="tw-mt-[-200px] tw-bg-white tw-relative tw-p-6 lg:tw-p-12 tw-space-y-8 tw-text-darkGreen">
            <h3 class="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-uppercase tw-text-center">
                Data Privacy
            </h3>

            <!-- Mobile -->
            <div class="tw-w-full tw-flex tw-justify-center md:tw-hidden">
                <div class="tw-relative tw-w-64">
                    <div class="tw-border-2 tw-border-solid tw-rounded tw-py-2 tw-px-4 tw-cursor-pointer tw-text-sm tw-font-bold tw-uppercase tw-text-gray-600 tw-bg-white tw-flex tw-justify-between tw-items-center"
                        @click="showDropdown = !showDropdown">
                        <span>
                            {{ activePolicy === 'OCLP' ? 'OCLP Data Privacy Policy' : 'OCC Data Privacy Policy' }}
                        </span>
                        <span class="tw-w-4 tw-h-4 tw-bg-no-repeat tw-bg-contain" :style="{
                            backgroundImage: showDropdown
                                ? 'url(/images/icons/caret-up-gray.svg)'
                                : 'url(/images/icons/caret-down-gray.svg)'
                        }" />
                    </div>
                    <div v-if="showDropdown"
                        class="tw-absolute tw-z-10 tw-w-full tw-bg-gray-50 tw-border tw-rounded tw-mt-1 tw-shadow">
                        <div class="tw-w-full tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-green-100 tw-text-sm tw-uppercase"
                            @click="activePolicy = 'OCLP'; showDropdown = false">
                            OCLP Data Privacy Policy
                        </div>
                        <div class="tw-w-full tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-bg-green-100 tw-text-sm tw-uppercase"
                            @click="activePolicy = 'OCC'; showDropdown = false">
                            OCC Data Privacy Policy
                        </div>
                    </div>
                </div>
            </div>

            <!-- Desktop -->
            <div
                class="tw-hidden md:tw-flex tw-flex-col lg:tw-flex-row md:tw-flex-row tw-items-center tw-justify-center tw-gap-4">
                <button @click="activePolicy = 'OCLP'"
                    :class="['tw-shadow-none tw-bg-white tw-py-2 tw-px-4 tw-border tw-rounded tw-uppercase tw-text-sm tw-font-bold tw-text-gray-500', activePolicy === 'OCLP' ? 'tw-border-2 tw-border-green-600 tw-text-green-700' : 'tw-border-white']">
                    OCLP Data Privacy Policy
                </button>
                <button @click="activePolicy = 'OCC'"
                    :class="['tw-shadow-none tw-bg-white tw-py-2 tw-px-4 tw-border tw-rounded tw-uppercase tw-text-sm tw-font-bold tw-text-gray-500', activePolicy === 'OCC' ? 'tw-border-2 tw-border-green-600 tw-text-green-700' : 'tw-border-white']">
                    OCC Data Privacy Policy
                </button>
            </div>

            <div class="tw-mb-6 tw-flex tw-justify-center">
                <img :src="activePolicy === 'OCLP' ? oclpImage : occImage" alt="Policy" loading="lazy"
                    class="tw-w-[200px] tw-h-auto tw-rounded" />
            </div>

            <OclpPolicy v-if="activePolicy === 'OCLP'" />
            <OccPolicy v-else />

        </div>
    </div>
    <a href="#" class="back-to-top" id="scroll-top"><span class="tw-text-xl tw-font-black">&#8593;</span> <br />
        BACK TO <br />TOP
    </a>
</template>
